import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    GET_PRICES_FOR_ITEMS,
    RESET_PRICES_FOR_ITEMS,
    SET_PRICES_FOR_ITEMS,
} from '../actions/actionTypes';

const initialState = {
    pricedItems: [],
    pricingStatusArray: [],
    isPricingDone: false,
    pricesForItemsLoading: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const getPricingStatusArray = (payload) => {
    const result = [];

    if (Array.isArray(payload?.products) && payload.products.length > 0) {
        payload.products.forEach((product) => {
            result.push({
                cfn: product?.cfn || product?.productCFN,
                loading: true,
            });
        });
    }

    if (Array.isArray(payload?.bundleProducts) && payload.bundleProducts.length > 0) {
        payload.bundleProducts.forEach((product) => {
            result.push({
                cfn: product?.cfn || product?.productCFN,
                loading: true,
            });
        });
    } else if (typeof payload?.bundleProducts === 'string') {
        const bundleCFN = payload.bundleProducts
            .split(',')
            .map((cfn) => cfn.trim())
            .find((cfn) => /^m/i.test(cfn));

        if (bundleCFN) {
            result.push({ cfn: bundleCFN, loading: true });
        }
    }

    return result;
};

const getPricesForItemsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRICES_FOR_ITEMS:
            return {
                ...state,
                // pricedItems: [],
                isPricingDone: false,
                pricesForItemsLoading: true,
                pricingStatusArray: getPricingStatusArray(action?.payload),
            };
        case SET_PRICES_FOR_ITEMS:
            return {
                ...state,
                pricedItems: action.payload,
                isPricingDone: false,
                pricesForItemsLoading: false,
            };
        case GET_PRICES_FOR_ITEMS_SUCCESS: {
            const newItems = action.payload.items || [];
            const newCFNSet = new Set(newItems.map(item => item.productCFN || item.cfn));
            const mergedItems = [
                ...(state.pricedItems || []).filter(item => !newCFNSet.has(item.productCFN || item.cfn)),
                ...newItems,
            ];
            return {
                ...state,
                pricedItems: mergedItems,
                isPricingDone: false,
                pricesForItemsLoading: false,
                pricingStatusArray: initialState.pricingStatusArray,
            };
        }
        case GET_PRICES_FOR_ITEMS_SUCCESS: {
            const newItems = action.payload.items || [];
            let updatedPricedItems;
            if (action.payload.fromSearch) {
                const newCFNSet = new Set(newItems.map(item => item.productCFN || item.cfn));
                updatedPricedItems = [
                    ...(state.pricedItems || []).filter(item => !newCFNSet.has(item.productCFN || item.cfn)),
                    ...newItems,
                ];
            } else {
                updatedPricedItems = newItems;
            }
            return {
                ...state,
                pricedItems: updatedPricedItems,
                isPricingDone: false,
                pricesForItemsLoading: false,
                pricingStatusArray: initialState.pricingStatusArray,
            };
        }
        case RESET_PRICES_FOR_ITEMS:
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'equityGetPricesForItemsKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    getPricesForItemsReducer
);
